import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ModelDetail from "./ModelDetail.jsx";
import AdComponent from './AdComponent';
import Subscription from "./Subscription.jsx";
var Spinner = require('react-spinkit');

class Home extends Component {
  constructor() {
    super();
    this.state = {
      models: [],
      filtered_models: [],
      filter: "",
      loaded: false,
    }

    this.filterModels = this.filterModels.bind(this);
    this.filterChanged = this.filterChanged.bind(this);

    axios.all([
      // Load a small model list for display purposes
      axios.get(process.env.REACT_APP_API + '/api/models/50/')
    ])
    .then(axios.spread((models_response) => {
      this.setState({models: models_response.data.models, filtered_models: models_response.data.models, loaded: true});

      // Load full model list
      axios.all([
        axios.get(process.env.REACT_APP_API + '/api/models/0/')
      ])
      .then(axios.spread((full_model_response) => {
        const models = full_model_response.data.models;
        this.setState({models: models });
        this.filterModels(this.state.filter);
      }));
    }));
  }
  
  filterModels(filter) {
    if(this.state.models) {
      const filtered_models = this.state.models.filter(model =>
        model.title.toUpperCase().includes(filter.toUpperCase()) ||
        (model.description && model.description.toUpperCase().includes(filter.toUpperCase())) ||
        this.props.frameworks[model.framework].title.toUpperCase().includes(filter.toUpperCase()));
      this.setState({ filtered_models: filtered_models });
    }
  }

  filterChanged(event) {
    const filter = event.target.value;
    this.setState({ filter: filter });
    this.filterModels(filter);
  }

  render() {
    const searchForm = <div className="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
      </div>
      <input name="filter" placeholder="Filter models..." type="text" className="form-control" value={this.state.filter} onChange={this.filterChanged} />
      </div>;

    const models = this.state.filtered_models ? (this.state.filtered_models.map((model, index) => {
          return <ModelDetail key={model.slug} framework={this.props.frameworks[model.framework]} model={model}/>;
        })) : "";
    const modelDisplay = []

    for(var i = 0; i < models.length; i ++) {
      modelDisplay.push(models[i]);

      if(i == 9 || i == 20) {
        // modelDisplay.push(<div className="email-div-home col-md-4 d-flex align-items-stretch"><Subscription /></div>);
        modelDisplay.push(<div className="col-md-4 advertisement-div"><AdComponent /></div>);
      }
    }

    return <div>
    <div className="jumbotron">
    <h1>Model Zoo</h1>
    <p>Discover open source deep learning code and pretrained models.</p>
    <Link to="/frameworks" className="btn btn-primary">Browse Frameworks</Link>
    <Link to="/categories" className="btn btn-primary">Browse Categories</Link>
    </div>
    {searchForm}
    <hr/>

    { this.state.loaded ? "" : <Spinner name="three-bounce" fadeIn="none" /> }

    <div className="row">
    { modelDisplay }
    </div>

    </div>
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/Home.jsx